/* ============ about.js — ports HorizontalScroll, useTravellingBean,
   useHeadingSwap (all GSAP) + BeansAnnotation (Framer Motion -> IO) ============ */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(cb) {
    // wait for GSAP (loaded deferred in <head>) + DOM
    var tries = 0;
    (function wait() {
      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        if (document.readyState !== 'loading') cb();
        else document.addEventListener('DOMContentLoaded', cb);
      } else if (tries++ < 100) {
        setTimeout(wait, 50);
      }
    })();
  }

  ready(function () {
    var root = document.querySelector('[data-about]');
    if (!root) return;
    gsap.registerPlugin(ScrollTrigger);

    var container = root.querySelector('[data-hscroll]');
    var track = root.querySelector('[data-hscroll-track]');
    var bean = root.querySelector('[data-bean]');
    var beanCenter = root.querySelector('[data-bean-center]');
    var headings = Array.prototype.slice.call(root.querySelectorAll('[data-swap-heading]'));
    var sectionCount = 3;
    var desktop = window.innerWidth >= 768;

    /* ---- Annotation reveal (replaces framer-motion useInView, amount 0.3) ---- */
    var annot = root.querySelector('[data-annot]');
    if (annot) {
      if (!('IntersectionObserver' in window) || reduce) {
        annot.classList.add('is-visible');
      } else {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            annot.classList.toggle('is-visible', e.isIntersecting);
          });
        }, { threshold: 0.3 }).observe(annot);
      }
    }

    if (!desktop || reduce) return; // horizontal pin + bean choreography are desktop-only (matches source)

    /* ---- HorizontalScroll: pin container, slide track ---- */
    if (container && track) {
      gsap.to(track, {
        x: function () { return -(window.innerWidth * (sectionCount - 1)); },
        ease: 'none',
        scrollTrigger: {
          trigger: container, pin: true, scrub: 1, invalidateOnRefresh: true,
          end: function () { return '+=' + window.innerWidth * (sectionCount - 1); }
        }
      });
    }

    /* ---- useHeadingSwap: headings slide up / fade across the pin ---- */
    if (container && headings.length) {
      gsap.set(headings[0], { y: 0, opacity: 1 });
      headings.slice(1).forEach(function (h) { gsap.set(h, { y: 60, opacity: 0 }); });
      var totalScroll = window.innerWidth * (sectionCount - 1);
      ScrollTrigger.create({
        trigger: container, start: 'top top', end: function () { return '+=' + totalScroll; }, scrub: 1,
        onUpdate: function (self) {
          var raw = self.progress * (sectionCount - 1);
          headings.forEach(function (h, i) {
            var d = raw - i;
            if (d < -0.5) gsap.set(h, { y: 60, opacity: 0 });
            else if (d < 0) { var p = (d + 0.5) / 0.5; gsap.set(h, { y: 60 - 60 * p, opacity: p }); }
            else if (d < 0.5) gsap.set(h, { y: 0, opacity: 1 });
            else if (d < 1) { var q = (d - 0.5) / 0.5; gsap.set(h, { y: -60 * q, opacity: 1 - q }); }
            else gsap.set(h, { y: -60, opacity: 0 });
          });
        }
      });
    }

    /* ---- useTravellingBean: one fixed bean, three scroll phases ---- */
    if (bean) {
      // Phase 1: hero resting state
      gsap.set(bean, {
        position: 'fixed', right: '0%', bottom: '0%', left: 'auto', top: 'auto',
        xPercent: 0, yPercent: 0, width: 'clamp(140px,14vw,220px)',
        filter: 'blur(6px)', opacity: 0.75, zIndex: 40, transformOrigin: 'center center'
      });

      // Phase 1->2: drift up & sharpen over the first ~0.8vh of scroll
      ScrollTrigger.create({
        trigger: 'body', start: 'top top', end: function () { return '+=' + window.innerHeight * 0.8; }, scrub: 1.2,
        onUpdate: function (self) {
          var p = self.progress;
          gsap.set(bean, {
            filter: 'blur(' + (6 - p * 6) + 'px)', opacity: 0.75 + p * 0.25,
            bottom: (p * 60) + '%', right: (2 + p * 3) + '%'
          });
        }
      });

      // Phase 2: lock to top-right while the horizontal track is pinned
      if (container) {
        ScrollTrigger.create({
          trigger: container, start: 'top top', end: 'bottom top',
          onEnter: function () {
            gsap.to(bean, { bottom: 'auto', top: '12%', right: '3%', filter: 'blur(0px)', opacity: 1, width: 'clamp(100px,10vw,160px)', duration: 0.5, ease: 'power2.out' });
          },
          onLeaveBack: function () {
            gsap.to(bean, { top: 'auto', bottom: '0%', right: '0%', filter: 'blur(6px)', opacity: 0.75, width: 'clamp(140px,14vw,220px)', duration: 0.4 });
          }
        });
      }

      // Phase 3: travel into the annotation center, grow, then fade
      if (beanCenter) {
        var centerW = function () { var vw = window.innerWidth; return vw >= 1536 ? vw * 0.40 : (vw >= 640 ? vw * 0.36 : vw * 0.45); };
        var startW = function () { return Math.min(Math.max(window.innerWidth * 0.10, 100), 160); };
        var lock = function () {
          var r = beanCenter.getBoundingClientRect(), endW = centerW(), vw = window.innerWidth;
          var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
          gsap.set(bean, { top: (((cy - endW / 2) / window.innerHeight) * 100) + '%', right: (((vw - cx - endW / 2) / vw) * 100) + '%', width: endW + 'px', opacity: 1, filter: 'blur(0px)' });
        };
        ScrollTrigger.create({
          trigger: beanCenter, start: 'top 80%', end: 'bottom bottom', scrub: 1.5,
          onUpdate: function (self) {
            var p = self.progress, travelP = Math.min(p / 0.6, 1);
            var r = beanCenter.getBoundingClientRect(), vw = window.innerWidth;
            var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
            var w = startW() + (centerW() - startW()) * travelP;
            var fr = ((vw - cx - w / 2) / vw) * 100, ft = ((cy - w / 2) / window.innerHeight) * 100;
            gsap.set(bean, { top: (12 + (ft - 12) * travelP) + '%', right: (3 + (fr - 3) * travelP) + '%', width: w + 'px', opacity: 1, filter: 'blur(0px)' });
          },
          onLeave: function () { lock(); gsap.to(bean, { opacity: 0, duration: 0.4, ease: 'power2.in' }); },
          onEnterBack: function () { gsap.to(bean, { opacity: 1, duration: 0.2 }); },
          onLeaveBack: function () { gsap.to(bean, { top: '12%', right: '3%', width: startW() + 'px', opacity: 1, filter: 'blur(0px)', duration: 2.5, ease: 'power2.out' }); }
        });
      }
    }
  });
})();
